const newsNoFeatured = {
    mixins: [mixins],
    data() {
        return {
            value: "",
            tabs: [],
            tab: "all",
            tabItem: null,
            handler: "",
            errorDialog: false,
            errorMsgs: [],
            records: [],
            loading: true,
            page: 1,
            allItems: 0,
        };
    },
    mounted() {},
    methods: {
        reset() {
            this.records = [];
            this.page = 1;
        },

        changeTab(newTab) {
            api.fn.moveWindowToObj(jQuery(".s-news"), 0, () => {
                this.$refs["tabs"].changeTab(newTab);
            });
        },

        tabChanged(newTab) {
            this.reset();

            this.tab = newTab;
            this.tabItem = this.tabs.filter((x) => x.id === newTab)[0];

            this.doSearch();
        },

        doSearch() {
            this.loading = true;
            this.errorMsgs = [];

            try {
                axios
                    .get(this.handler + "?value=" + this.tab + "&page=" + this.page + "&t=" + Math.floor(Date.now() / 1000))
                    .then((response) => {
                        var { hasError, errorMessages, data, allItems } = response.data;

                        if (hasError) {
                            this.handleError(errorMessages);
                            return false;
                        }

                        this.handleSuccess(data, allItems);
                    })
                    .catch((errors) => {
                        this.handleError([errors]);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            } catch (err) {
                this.loading = false;
                this.handleError(JSON.parse(err));
            }
        },

        handleError(messages) {
            this.errorMsgs = this.hasValue(messages) ? messages : [];
            this.errorDialog = true;
        },

        handleSuccess(data, allItems) {
            this.records = [];

            this.$nextTick(() => {
                this.allItems = parseInt(allItems);

                this.records = [].concat(...data);
            });
        },

        pageChanged(newPage) {
            this.page = newPage;

            this.doSearch();
            this.scrollToElem(jQuery(".s-news"));
        },
    },
    computed: {},
};

var newsNoFeaturedApp = Vue.createApp(newsNoFeatured);
if (document.querySelector("#v-news-no-featured")) {
    newsNoFeaturedApp.directive("init", initDirective);
    newsNoFeaturedApp.component("b-tabs", bTabs);
    newsNoFeaturedApp.component("b-pagination", bPagination);
    newsNoFeaturedApp.component("alert-danger", alertDanger);
    newsNoFeaturedApp.mount("#v-news-no-featured");
}
